import React from 'react';
import {
  Button as MuiButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface DeleteTemplateConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteTemplateConfirmationDialog: React.FC<
  DeleteTemplateConfirmationDialogProps
> = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          Are you sure you want to delete this template? This action cannot be
          undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <MuiButton onClick={onClose} color='primary'>
          Cancel
        </MuiButton>
        <MuiButton onClick={onConfirm} color='error' autoFocus>
          Delete
        </MuiButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteTemplateConfirmationDialog;
